import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DeleteButtonProps {
	onClick: () => void;
}

const DeleteButton = ({ onClick }: DeleteButtonProps) => {
	return (
		<Button
			type="button"
			variant="ghost"
			size="icon"
			className="ml-2 h-8 w-4 text-destructive  hover:bg-destructive/0"
			onClick={onClick}
			aria-label="Verwijder medewerker"
			data-testid="employee-delete-button"
		>
			<X className="h-5 w-5" strokeWidth={4} />
		</Button>
	);
};

export default DeleteButton;
